"use client"

import { usePixelInjectionPermissionSisal } from "@/hooks/use-pixel-injection-permission"
import Script from "next/script"

export function TradedeskAllPagesPixelScriptSisal() {
  const canInjectPixels = usePixelInjectionPermissionSisal()

  if (!canInjectPixels) return null

  return (
    <>
      <Script
        id="tradedesk-loader-all-pages-pixel-sisal"
        src="https://js.adsrvr.org/up_loader.3.0.0.js"
        async
      />
      <Script id="tradedesk-all-pages-pixel-sisal">
        {`
          window.ttdConversionEventsLayer = window.ttdConversionEventsLayer || []
          function ttdConversionEvents() {
            window.ttdConversionEventsLayer.push(arguments)
          }

          ttdConversionEvents("init", {
            advertiserId: "1egpyf1",
            pixelIds: ["mlt68bh"],
          })

          ttdConversionEvents("event", {
            advertiserId: "1egpyf1",
            pixelIds: ["mlt68bh"],
          })
        `}
      </Script>
    </>
  )
}
